import React, { Component } from 'react';
import { connect } from 'react-redux';
import countries from 'country-calling-code';
import {
  Modal,
  Col,
  Row,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Radio,
} from 'react-bootstrap';
import actions from '../../redux/actions';
import { Contributions } from '../../constants';
import { getWorkTypeNameById, getSubWorkTypeNameById } from '../../utils';

const DEFAULT_MUSIC_CONTRIBUTIONS = [
  'Sound Recording',
  'Musical Composition + Sound Recording',
];

class EditAuthor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anonymous: false,
      pseudonym: '',
      firstName: '',
      lastName: '',
      middleName: '',
      organization: '',
      originType: 'citizenship',
      country: null,
      selectedContributions: [],
      workforhire: -1,
    };
  }

  opened() {
    const { author, fields, subWorkTypes } = this.props;
    this.setState({
      organization: author ? author.organization || '' : '',
      firstName: author ? author.firstName || '' : '',
      middleName: author ? author.middleName || '' : '',
      lastName: author ? author.lastName || '' : '',
      pseudonym: author ? author.pseudonym || '' : '',
      workforhire: author ? author.workforhire : -1,
      country: author ? author.country : '',
    });

    if (author && author.citizenship) {
      this.setState({ country: author.citizenship });
    } else if (author && author.domicile) {
      this.setState({ country: author.domicile });
    }

    if (author) {
      this.setState({ selectedContributions: author.contributions });
    } else {
      // Set "Sound Recording" as default contributions if user selected "Music" or "Music + Sound Recording" from Creg type.
      const subTypeName = getSubWorkTypeNameById(fields.subType, subWorkTypes);
      if (DEFAULT_MUSIC_CONTRIBUTIONS.includes(subTypeName)) {
        this.setState({ selectedContributions: ['Sound Recording'] });
      }
    }

    this.setState({
      anonymous: author ? author.anonymous : false,
      originType: author && author.domicile ? 'domicile' : 'citizenship',
    });
  }

  close() {
    this.props.onClose();
  }

  save(e) {
    e.preventDefault();
    const {
      firstName,
      lastName,
      middleName,
      pseudonym,
      organization,
      selectedContributions,
      workforhire,
      country,
    } = this.state;

    if (workforhire === -1) {
      this.props.alert('error', 'Please check the required fields.');
      return;
    }

    let data = {};
    if (organization === '') {
      data = {
        firstName,
        lastName,
        middleName,
        citizenship:
          this.state.originType === 'citizenship' ? this.state.country : '',
        domicile:
          this.state.originType === 'domicile' ? this.state.country : '',
        anonymous: this.state.anonymous,
        pseudonym,
        workforhire,
        contributions: selectedContributions,
        country,
      };
    } else {
      data = {
        organization,
        citizenship:
          this.state.originType === 'citizenship' ? this.state.country : '',
        domicile:
          this.state.originType === 'domicile' ? this.state.country : '',
        anonymous: this.state.anonymous,
        pseudonym,
        workforhire,
        contributions: selectedContributions,
        country,
      };
    }

    this.props.hideAlert();

    if (
      data.organization
        ? data.organization === ''
        : data.firstName === '' || !(data.citizenship || data.domicile)
    ) {
      this.props.alert('error', 'Please check the required fields.');
      return;
    }

    if (
      organization !== '' &&
      (firstName !== '' || lastName !== '' || middleName !== '')
    ) {
      this.props.alert('error', 'You must list an organization OR a person');
      return;
    }

    const typeName = getWorkTypeNameById(
      this.props.fields.type,
      this.props.workTypes
    );
    const subTypeName = getSubWorkTypeNameById(
      this.props.fields.subType,
      this.props.subWorkTypes
    );

    if (data.contributions.length === 0) {
      if (
        typeName === 'Music' &&
        subTypeName === DEFAULT_MUSIC_CONTRIBUTIONS[1]
      ) {
        this.props.alert(
          'error',
          'Sorry, in order to register both the sound recording(s) and composition(s) together, each author must have contributed to the sound recording and the composition (music+lyrics). Please correct the contribution section to move forward or, register the sound recording(s) and compositions(s) separately.'
        );
      } else {
        this.props.alert('error', 'Please check the required fields.');
      }
      return;
    }

    this.props.onSave(data);
    this.close();
  }

  handleChange(e, isAnonymous) {
    this.setState({
      anonymous: isAnonymous ? e.target.checked : !e.target.checked,
      pseudonym: isAnonymous ? !e.target.checked : e.target.checked,
    });
  }

  handleFirstName(e) {
    this.setState({
      firstName: e.target.value,
    });
    this.clearRestField();
  }

  handleLastName(e) {
    this.setState({
      lastName: e.target.value,
    });
    this.clearRestField();
  }

  handleMiddleName(e) {
    this.setState({
      middleName: e.target.value,
    });
    this.clearRestField();
  }

  clearRestField() {
    this.setState({
      organization: '',
      pseudonym: '',
    });
  }

  handlePseudonym(e) {
    this.setState({
      pseudonym: e.target.value,
      firstName: e.target.value,
      lastName: '',
    });
  }

  handleOrganization(e) {
    this.setState({
      organization: e.target.value,
      firstName: '',
      lastName: '',
      middleName: '',
    });
  }

  handleOriginChange(originType) {
    this.setState({ originType });
  }

  handleCountry(country) {
    this.setState({ country });
  }

  handleWorkForHire(workforhire) {
    this.setState({ workforhire });
  }

  handleContributions = (e) => {
    const { options } = e.target;
    let value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }

    // Prevent "Sound Recording" unselect from contributions unless user have chosen "Musical Composition + Sound Recording".
    const subTypeName = getSubWorkTypeNameById(
      this.props.fields.subType,
      this.props.subWorkTypes
    );
    if (subTypeName === DEFAULT_MUSIC_CONTRIBUTIONS[1]) {
      if (!value.includes(DEFAULT_MUSIC_CONTRIBUTIONS[0])) {
        value = [...value, DEFAULT_MUSIC_CONTRIBUTIONS[0]];
      }
    }
    this.setState({ selectedContributions: value });
  };

  render() {
    const { workTypes, subWorkTypes, fields } = this.props;
    const {
      country,
      originType,
      firstName,
      lastName,
      middleName,
      pseudonym,
      organization,
      workforhire,
    } = this.state;
    const typeName = getWorkTypeNameById(fields.type, workTypes);
    const subTypeName = getSubWorkTypeNameById(fields.subType, subWorkTypes);

    let contributions = Contributions[typeName];
    if (typeName === 'Music') {
      if (subTypeName === 'Musical Composition') {
        contributions = ['Lyrics', 'Music'];
      } else if (subTypeName === 'Sound Recording') {
        contributions = ['Sound Recording'];
      } else {
        contributions = ['Lyrics', 'Sound Recording', 'Music'];
      }
    }

    return (
      <Modal
        className="edit-author-modal"
        show={this.props.open}
        onEnter={() => this.opened()}
        onHide={() => this.close()}
      >
        <Form inline onSubmit={(e) => this.save(e)}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Author</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* <p>You can list an organization OR a person as an author.</p> */}
            <Row>
              <Col sm={4}>
                <FormGroup>
                  <ControlLabel className="w-100px">
                    <span className="text-red">*</span>First Name:{' '}
                  </ControlLabel>
                  <FormControl
                    type="text"
                    value={firstName}
                    onChange={(e) => this.handleFirstName(e)}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel className="w-100px">Middle Name: </ControlLabel>
                  <FormControl
                    type="text"
                    value={middleName}
                    onChange={(e) => this.handleMiddleName(e)}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel className="w-100px">
                    <span className="text-red">*</span>Last Name:{' '}
                  </ControlLabel>
                  <FormControl
                    type="text"
                    value={lastName}
                    onChange={(e) => this.handleLastName(e)}
                  />
                </FormGroup>
              </Col>
              <Col sm={4} className="section-divider">
                <FormGroup>
                  <Row>
                    <Col sm={12}>
                      <ControlLabel>Pseudonym: </ControlLabel>
                      <FormControl
                        type="text"
                        value={pseudonym}
                        onChange={(e) => this.handlePseudonym(e)}
                      />
                    </Col>
                    <br />
                    <br />
                    <Col sm={12}>
                      <p>
                        If the author (an individual, not a group) does not want
                        their real name to appear in the registration, list
                        their moniker/stage name in the space provided above.
                        <br />
                        <br />
                        <b>
                          You can only do this if the author’s real name does
                          not appear anywhere on copies of the work.
                        </b>
                      </p>
                    </Col>
                  </Row>
                </FormGroup>
                <div className="section-divider-left-or">OR</div>
                <div className="section-divider-right-or">OR</div>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Row>
                    <Col sm={12}>
                      <ControlLabel className="w-100px">
                        Organization:{' '}
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={organization}
                        onChange={(e) => this.handleOrganization(e)}
                      />
                    </Col>
                    <br />
                    <br />
                    <Col sm={12}>
                      <p className="small">
                        If an organization owns this work (e.g. has commissioned
                        it) list the organization here.
                      </p>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>
            <br />
            <br />

            <Row>
              <Col sm={5}>
                <FormGroup>
                  <ControlLabel>
                    <span className="text-red">*</span>Citizenship:{' '}
                  </ControlLabel>
                  <br />
                  <br />
                  <Radio
                    checked={originType === 'citizenship'}
                    onChange={() => this.handleOriginChange('citizenship')}
                  >
                    Citizenship
                  </Radio>
                  <Radio
                    checked={originType === 'domicile'}
                    onChange={() => this.handleOriginChange('domicile')}
                  >
                    Domicile
                  </Radio>
                  <FormControl
                    componentClass="select"
                    value={country && country !== '' ? country : -1}
                    ref={(r) => (this.country = r)}
                    className="fixed"
                    onChange={(e) => this.handleCountry(e.target.value)}
                  >
                    <option disabled key={-1} value={-1}>
                      Select Country
                    </option>
                    {countries.map((country, i) => (
                      <option key={i} value={country.country}>
                        {country.country}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col sm={7}>
                <FormGroup>
                  <ControlLabel>
                    <span className="text-red">*</span>Did this author pay to
                    have the work(s) completed on a "work for hire" basis?
                  </ControlLabel>
                  <br />
                  <br />
                  <FormControl
                    componentClass="select"
                    value={workforhire}
                    onChange={(e) => this.handleWorkForHire(e.target.value)}
                  >
                    <option disabled value={-1}>
                      Select
                    </option>
                    <option value={false}>No</option>
                    <option value={true}>Yes</option>
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
            <br />

            <Row>
              <Col sm={5}>
                <FormGroup>
                  <ControlLabel>
                    <span className="text-red">*</span>Contribution:{' '}
                  </ControlLabel>
                  <p className="small">
                    Use "shift" + click to select multiple options
                  </p>
                  <FormControl
                    ref={(r) => (this.contributions = r)}
                    componentClass="select"
                    size="4"
                    multiple
                    value={this.state.selectedContributions}
                    onChange={this.handleContributions}
                  >
                    {contributions &&
                      contributions.map((contribution, i) => (
                        <option key={i} value={contribution}>
                          {contribution}
                        </option>
                      ))}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <div className="actions">
              <button type="submit">Save</button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypesCoreg,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAuthor);



// WEBPACK FOOTER //
// src/components/Copyright/EditAuthorPopup.jsx